'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/* \n* ink colors (with variations only for black and white)\n*/\n.lp-badge--default, .lp-badge--danger, .lp-badge--success, .lp-badge--warning, .lp-badge--primary {\n  display: inline-flex;\n  max-height: 24px;\n  width: fit-content;\n  border-radius: 5px;\n  padding: 0 calc(0.5 * 1rem);\n  box-sizing: border-box;\n}\n\n.lp-badge--primary {\n  color: #1D66DD;\n  background-color: #d0ddf5;\n  border: 1px solid currentColor;\n}\n\n.lp-badge--warning {\n  color: #faaf40;\n  background-color: #feefd9;\n  border: 1px solid currentColor;\n}\n\n.lp-badge--success {\n  color: #1ec494;\n  background-color: #d2f3ea;\n  border: 1px solid currentColor;\n}\n\n.lp-badge--danger {\n  color: #f95151;\n  background-color: #fbdbdb;\n  border: 1px solid currentColor;\n}\n\n.lp-badge--default {\n  color: #717171;\n  background-color: #f5f5f5;\n  border: 1px solid currentColor;\n}");
//# sourceMappingURL=Badge.scss.js.map
